export const tableHeader = [
  'Type',
  'Name',
  'Start Date',
  'End Date',
  'Leave Status',
  'Day Status',
  'Action'
]

export const ActionList = [
  {
    id: 'Approved',
    name: 'Approved Leaves'
  },
  {
    id: 'Rejected',
    name: 'Rejected Leaves'
  },
  {
    id: 'Show All',
    name: 'Show All Leaves'
  }
]
